import { render } from "./addLog.vue?vue&type=template&id=2baf6ec5&scoped=true"
import script from "./addLog.vue?vue&type=script&lang=js"
export * from "./addLog.vue?vue&type=script&lang=js"

import "./addLog.vue?vue&type=style&index=0&id=2baf6ec5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baf6ec5"]])

export default __exports__